module.exports = __webpack_public_path__ + "assets/campaigns-active.24673741.svg";